module.exports = __webpack_public_path__ + "static/media/popup-pottencial-promotion.24273edc.png";